
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"search\"><path d=\"M7.413 46.096L17.98 35.53a18.362 18.362 0 0010.093 3.006c10.184 0 18.42-8.254 18.42-18.439 0-10.165-8.235-18.42-18.42-18.42-10.167 0-18.419 8.255-18.419 18.42 0 3.556 1.001 6.868 2.733 9.675L1.744 40.41c-.563.548-.09 1.915 1.04 3.042l1.585 1.589c1.13 1.128 2.497 1.6 3.044 1.054zm8.362-26c0-6.796 5.503-12.298 12.299-12.298 6.796 0 12.316 5.502 12.316 12.298 0 6.797-5.52 12.317-12.316 12.317-6.796 0-12.299-5.52-12.299-12.317z\" /></symbol>"
});
    sprite.add(symbol);

    export default class SearchSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="search" {...this.props} />;
      }
    }
  